// extracted by mini-css-extract-plugin
export default {"page_container":"LaserficheEmbed_page_container__mHmDX","iframe_container":"LaserficheEmbed_iframe_container__qVdj1"};